<template>
  <section
    v-if="feedbackType == 'material'"
    class="background w-screen flex items-center justify-center flex-col h-screen fixed top-0 left-0 z-50"
  >
    <div
      class="box-complete-items-msg bg-bl flex flex-col md:flex-row space-y-4 md:space-x-8 justify-center items-center md:items-start pb-8"
      v-motion
      :initial="initialMotion"
      :enter="enterMotion"
    >
      <div class="md:w-1/2">
        <div
          class="message-box bg-white rounded-lg px-8 py-8 flex flex-col lg:flex-row items-center border-b-4 border-yellow-500"
        >
          <div class="w-[25%] h-48 flex justify-center items-center">
            <img :src="homeroAvatar" class="avatar-homero" alt="avatarHomero" />
          </div>
          <div class="w-[80%]">
            <div class="flex justify-center flex-row space-x-2">
              <h1 class="text-xl md:text-2xl text-center">
                {{
                  $t("labels.generic", {
                    pt: "O conteúdo apresentado foi satisfatório?",
                    en: "Was the content presented satisfactory?",
                  })
                }}
              </h1>
            </div>
            <div class="flex flex-row">
              <MessageVoice
                msg="O conteúdo apresentado foi satisfatório?"
                :showPlayButton="false"
                :showRepeatButton="false"
                :showSpeedButton="false"
                @onEndMessage="permissToListen"
              />
            </div>
            <div
              class="mt-8 flex flex-row w-full items-center justify-center gap-8"
            >
              <Button
                :class="`btn-outline`"
                :disabled="talking"
                @click="sendLike(true)"
              >
                <div :class="`flex gap-2 items-center ${active.like}`">
                  <v-icon
                    name="md-thumbup-outlined"
                    class="text-green-500"
                    scale="1.5"
                  />
                </div>
              </Button>
              <Button
                :class="`btn-outline`"
                :disabled="talking"
                @click="sendLike(false)"
              >
                <div :class="`flex gap-2 items-center ${active.dislike}`">
                  <v-icon
                    name="md-thumbdown-outlined"
                    class="text-h-error-400"
                    scale="1.5"
                  />
                </div>
              </Button>
            </div>
            <div class="w-full flex justify-center items-center mt-8 space-x-4">
              <v-icon name="md-spatialaudiooff" class="text-primary-400" />
              <p>
                {{
                  $t("labels.generic", {
                    pt: "Você também pode responder por voz. Ex: 'Sim', 'Gostei' ou 'Não'",
                    en: "You can also reply by voice. Ex: 'Yes', 'Like' or 'No'",
                  })
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RecordStream v-show="recording" ref="recordStream" encodeType="liked" />
  </section>
  <section v-if="feedbackType == 'objective'">
    <FeedbackObjective
      :itemId="itemId"
      :idCourse="idCourse"
      :idUser="idUser"
      @onSendFeedback="sendFeedback"
    />
  </section>
</template>

<script lang="ts">
import { ChatBotService } from "@/components/ChatBot/chat-bot.service";
import { RecordService } from "@/components/RecordStream/record.service";
import {
  MotionEnter,
  MotionInitial,
  MotionTransition,
} from "@/models/motion.model";
import { FeedbackRest } from "@/services/rest/feedback.rest";
import { Subscription } from "rxjs";
import { defineComponent } from "vue";
import { feedbackObjectIsOpen$ } from "./feedback-component.service";
import FeedbackObjective from "./FeedbackObjective/feedback-objective.vue";

export default defineComponent({
  name: "feedback-component",
  emits: ["onSendFeedback", "onSendLike"],
  components: {
    FeedbackObjective,
  },
  data() {
    return {
      homeroAvatar: require("@/assets/images/avatares/avatar.svg"),
      loader: false,
      talking: true as boolean,
      recording: false as boolean,
      active: {
        like: "",
        dislike: "",
      } as any,
      initialMotion: new MotionInitial(),
      enterMotion: new MotionEnter(1, 0, 0, new MotionTransition(40)),
    };
  },
  props: {
    itemId: {
      required: true,
      type: String,
    },
    feedbackType: {
      type: String,
      default: "material",
    },
    idUser: {
      type: String,
      default: "userId",
    },
    idCourse: {
      type: String,
      default: "course",
    },
  },
  computed: {
    rest(): FeedbackRest {
      return new FeedbackRest();
    },
    chatbot(): ChatBotService {
      return new ChatBotService();
    },
  },
  created() {
    this.wsSubscription();
  },
  mounted() {
    if (this.feedbackType === "material") {
      feedbackObjectIsOpen$.next(true);
    }
  },
  methods: {
    sendLike(value: boolean): void {
      this.active.like = value ? "animate-ping" : "";
      this.active.dislike = !value ? "animate-ping" : "";
      feedbackObjectIsOpen$.next(false);
      this.$emit("onSendLike", value);
    },
    sendFeedback(data: object): void {
      this.$emit("onSendFeedback", data);
    },
    permissToListen(): void {
      this.recording = true;
      this.talking = false;
      (this.$refs.recordStream as any)?.sendActionWithRecord();
    },
    wsSubscription(): Subscription {
      return this.chatbot.wsMessagesActions().subscribe((e) => {
        const parse = JSON.parse(e);
        if (parse?.hasAction && parse?.action?.type == "liked_action") {
          this.sendLike(parse?.action?.liked);
          this.recording = false;
        }
      });
    },
  },
});
</script>
<style lang="scss" src="./style.scss"></style>
